import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const DashboardContainer = styled.div`
  min-height: calc(100vh - 130px);
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${FONT_STACK};
  -webkit-font-smoothing: antialiased;

  @media (max-width: 800px) {
    margin-top: 160px;
    min-height: calc(100vh - 160px);
    padding: 1.5rem 1rem 6rem;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    margin-top: 160px;
    min-height: calc(100vh - 160px);
    padding: 2rem 1.5rem 6rem;
  }
`;

export const DashboardTitle = styled.h1`
  font-family: ${FONT_STACK};
  font-size: 2rem;
  font-weight: 700;
  color: var(--violetaOscuro);
  letter-spacing: -0.025em;
  text-align: center;
  margin: 0;

  span {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    color: var(--grisMedio);
    letter-spacing: -0.01em;
    margin-top: 0.5rem;
  }

  @media (max-width: 800px) {
    font-size: 1.5rem;
    span {
      font-size: 0.9rem;
    }
  }
`;

export const CardsGrid = styled.div`
  width: 100%;
  margin-top: 2.4rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-top: 1.5rem;
  }
`;

export const DashboardCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 28px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f3ebfa 100%);
  border: 1.5px solid rgba(76, 4, 140, 0.18);
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba(76, 4, 140, 0.04),
    0 8px 24px -8px rgba(76, 4, 140, 0.18);
  cursor: pointer;
  overflow: hidden;
  font-family: ${FONT_STACK};
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--violetaOscuro) 0%,
      var(--violeta) 50%,
      var(--naranja) 100%
    );
  }

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(76, 4, 140, 0.32);
    box-shadow:
      0 2px 4px rgba(76, 4, 140, 0.08),
      0 18px 38px -10px rgba(76, 4, 140, 0.32);
  }

  &:active {
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 1px 2px rgba(76, 4, 140, 0.04),
      0 8px 24px -8px rgba(76, 4, 140, 0.18),
      0 0 0 3px rgba(203, 182, 219, 0.45);
  }
`;

export const CardIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    var(--violetaPastelOscuro) 0%,
    var(--violetaOscuro) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  color: white;
  font-size: 1.75rem;
  box-shadow: 0 6px 16px rgba(76, 4, 140, 0.32);
`;

export const CardTitle = styled.h3`
  font-family: ${FONT_STACK};
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--violetaOscuro);
  letter-spacing: -0.015em;
  margin: 0 0 8px 0;
`;

export const CardDescription = styled.p`
  font-family: ${FONT_STACK};
  font-size: 0.88rem;
  font-weight: 400;
  color: var(--grisMedio);
  letter-spacing: -0.005em;
  line-height: 1.5;
  max-width: 280px;
  margin: 0;
`;
